/**
 * Modern design-system card surface with optional top frost.
 * Opt in: frost (or frost={true}). Prefer this over bare `getModernCardStyle` + View in Reports.
 */
import React, { memo } from 'react';
import { View, type StyleProp, type ViewStyle, type ViewProps } from 'react-native';
import { getModernCardStyle } from '@stylesheet';
import CardFrostStrip from './CardFrostStrip';
import type { FrostTone } from './frostTokens';

export function actionColorToFrostTone(
  color?: 'blue' | 'green' | 'red' | 'amber' | 'grey' | 'white' | string,
): FrostTone {
  switch (color) {
    case 'green':
      return 'green';
    case 'red':
      return 'red';
    case 'amber':
      return 'amber';
    case 'blue':
      return 'blue';
    case 'white':
    case 'grey':
    default:
      return 'default';
  }
}

export type ModernFrostedSurfaceProps = ViewProps & {
  theme: boolean;
  size?: 'small' | 'medium' | 'large';
  tone?: FrostTone;
  frost?: boolean;
  compact?: boolean;
  style?: StyleProp<ViewStyle>;
  children?: React.ReactNode;
};

const ModernFrostedSurface = memo(function ModernFrostedSurface({
  theme,
  size = 'medium',
  tone = 'default',
  frost = false,
  compact,
  style,
  children,
  ...rest
}: ModernFrostedSurfaceProps) {
  return (
    <View style={[getModernCardStyle(theme, size), style]} {...rest}>
      {frost ? <CardFrostStrip theme={theme} tone={tone} compact={compact} enabled /> : null}
      {children}
    </View>
  );
});

export default ModernFrostedSurface;
